import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import { find } from 'lodash';
import { CSSTransition } from 'react-transition-group';
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';
import { parse } from 'node-html-parser';

import { RichText } from '../assets/components';

async function loadPolyfills() {
  if (typeof window.IntersectionObserver === 'undefined') {
    await import('intersection-observer');
  }
}

loadPolyfills();

const Value = props => {
  const [base, significant] = props.end.toString().split('.');

  return (
    <CountUp
      start={props.start}
      end={props.inView ? props.end : props.start}
      duration={props.duration}
      useEasing={true}
      suffix={props.suffix}
      decimals={significant && significant.length}
      separator=","
    >
      {({ countUpRef }) => <h3 className={props.className} ref={countUpRef} />}
    </CountUp>
  );
};

export function BigNumber({ data, ...rest }) {
  const [ref, inView] = useInView({
    threshold: 0.5,
    triggerOnce: true,
    rootMargin: '-200px 0px -200px 0px',
  });
  const { attributes } = data;
  const [countingUp, setCountingUp] = useState(attributes.countingUp);
  const [countup, setCountup] = useState(0);
  const [suffix, setSuffix] = useState('');

  const {
    className,
    tagName: Tag,
    blockClass,
    prefix,
    value,
    unit,
    enableOutline,
    longNumber,
    tagline,
    content,
  } = attributes;

  useEffect(() => {
    if (!countingUp) return;

    try {
      const syntheticNode = parse(value.toString().replace(',', ''));
      const rawValue = find(syntheticNode.childNodes, { tagName: 'countup' });

      const countup = Number.parseFloat(rawValue.rawText);

      // console.log(`Raw value: ${value}`);
      // console.log(`Parsed value`);
      // console.log(syntheticNode);

      if (isNaN(countup)) {
        throw 'Value is NaN';
      }

      setCountup(countup);
      setSuffix(suffix);
    } catch (error) {
      setCountingUp(false);
    }
  }, []);

  const blockClasses = classnames(blockClass, className, {});

  const innerWrapClasses = classnames(`${prefix}__wrap`, {});

  const animationLayerClasses = classnames(`${prefix}__animation-layer`, {});

  const sideClasses = classnames(`${prefix}__side`, {});

  const valueClasses = classnames(`${prefix}__value`, {});
  
  const unitClasses = classnames(`${prefix}__unit`, {});

  const taglineClasses = classnames(`${prefix}__tagline`, {});

  const contentClasses = classnames(`${prefix}__paragraph`, {});
  
  const contentWrapperClasses = classnames(`${prefix}__paragraph-wrapper`, {});

  return (
    <>
        <Tag
          ref={ref}
          className={blockClasses}
          has-outline={`${enableOutline}`}
          has-counting-up={`${countingUp}`}
          long-number={`${longNumber}`}
          is-in-view={inView}
        >
          <div className={innerWrapClasses}>
            <div className={sideClasses}>
              {!countingUp && <RichText className={valueClasses} tagName="h3" value={value} />}
              {countingUp && (
                <Value
                  className={valueClasses}
                  start={0}
                  end={countup}
                  suffix={suffix}
                  delay={0}
                  duration={5}
                  inView={inView}
                />
              )}
              <RichText className={unitClasses} tagName="h5" value={unit} />
              <RichText className={taglineClasses} tagName="h4" value={tagline} />
              {content && (
                <div className={contentWrapperClasses}>
                  <RichText className={contentClasses} tagName="p" value={content} />
                  <i class="fal fa-chevron-right"></i>
                </div>
              )}
            </div>
          </div>
        </Tag>
    </>
  );
}
